import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AttendanceSubmissionRoutes = defineRoute({
    home: {
        route: {
            path: "/attendance-submission",
            component: () => loadView(import("./AttendanceSubmissionHome.vue")),
        },
    },
});
